import { FirmaElectronicaService } from './../../../services/firma-electronica/firma-electronica.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MessagesTitles, MessagesStatus } from 'app/models/messages';
import { GuiasService } from 'app/services/guias/guias.service';
import { Component, OnInit, AfterViewInit, Output, EventEmitter, Input, ChangeDetectorRef, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';
import {
  MultiSelectRepresentanteCLIComponent,
  MultiSelectRepresentanteIFComponent
} from 'app/componentes-globales/componentes-globales.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { EmpresasService } from '../../../services/empresas/empresas.service';
import { Persona } from '../../../models/Persona';
import { ActivatedRoute } from '@angular/router';
import Swal from "sweetalert2";
import * as moment from 'moment';
import { DatePipe } from "@angular/common";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS
} from "@angular/material";
import { environment } from 'environments/environment';
import { LINEA, CONFIG } from 'app/models/NuevoCMAdquirente.model';
export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY ",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};
declare var $: any;
@Component({
  selector: 'app-nuevo-contrato-marco',
  templateUrl: './nuevo-contrato-marco.component.html',
  styleUrls: ['./nuevo-contrato-marco.component.scss'],
  providers: [MessagesTitles, MessagesStatus, Persona, {
    provide: DateAdapter,
    useClass: MomentDateAdapter,
    deps: [MAT_DATE_LOCALE]
  },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})
export class NuevoContratoMarcoComponent implements OnInit, AfterViewInit {
  Label_Proveedor = environment.LABEL_PROVEEDOR;
  Label_Proveedores = environment.LABEL_PROVEEDORES;
  Label_Adquirente = environment.LABEL_ADQUIRENTE;
  Label_Adquirentes = environment.LABEL_ADQUIRENTES;
  Label_id_soles = environment.ID_GUIA_SOLES;
  Label_id_dolares = environment.ID_GUIA_DOLARES;
  Id_Confirming = environment.ID_CONFIRMING;
  Id_Factoring = environment.ID_FACTORING;
  Id_Descuento = environment.ID_DESCUENTO;
  Id_Tipo_Proceso_CM = environment.TIPO_PROCESO.CONTRATO_MARCO;
  @Input() idEmpresaProveedor: string;
  @Output() cerrarContratoMarcoNuevo: EventEmitter<boolean>;

  razSocial: string;
  loading: boolean = false;
  cargandoContactos: boolean = false;
  cargandoBancos: boolean = false;

  @ViewChild('multiselectIF', { static: false }) multiselectIF: MultiSelectRepresentanteIFComponent;
  @ViewChild('multiselectCLI', { static: false }) multiselectCLI: MultiSelectRepresentanteCLIComponent;
  save: boolean = false;
  contactosArray: any;
  user: any;
  formularioGenerarContrato: FormGroup;
  idEmpresa: string;
  Titulo: string;

  rProvCombo: any = [];
  rProvArray: any = [];
  rRefBancariaArray: any = [];
  rProvRefBancarias: any = [];
  rProvRefBancariasDolares: any = [];
  tipoServicio: any;

  selectedItems = [];
  selectedItemsCLI = [];

  abrirAgregarContacto: boolean;
  idContactoS: string;
  dataEnviar: any = {};
  dataEnviarKeynua: any = {};
  dataContract: any = [];
  tipoServicioElement = this.Id_Factoring;
  Codigo = '';
  Pagare: any;
  esConfirming = false;
  formConfig: FormGroup;
  lineaSoles: any = '';
  lineaDolares: any = '';
  linea: LINEA[] = [];
  config: CONFIG[] = [];
  Fecha = moment();

  constructor(
    private empresasService: EmpresasService,
    private routerActive: ActivatedRoute,
    private datePipe: DatePipe,
    private guiasService: GuiasService,
    private msgTitulos: MessagesTitles,
    private msgStatus: MessagesStatus,
    private firmaElectronicaService: FirmaElectronicaService,
    private cdr: ChangeDetectorRef) {

    this.cerrarContratoMarcoNuevo = new EventEmitter();
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.razSocial = sessionStorage.getItem('razSocial');
    this.Titulo = "Nuevo Pagaré";
    this.tipoServicio = this.empresasService.tipoServicio

    this.formularioGenerarContrato = new FormGroup({
      "idEmpresa": new FormControl('', Validators.required),
      "Tipo_Servicio": new FormControl(this.tipoServicioElement, Validators.required),
      "Fecha_Inicio": new FormControl('', Validators.required),
      "Fecha_Final": new FormControl('', Validators.required),
      "Pagare": new FormControl(false),
      "IF_Representante_Legal_1": new FormControl(''),
      "PRV_Representante_Legal_1": new FormControl(''),
      "IF_Representante_Legal_2": new FormControl(''),
      "PRV_Representante_Legal_2": new FormControl(''),
      "Correo": new FormControl(''),
      "BancoSoles": new FormControl(''),
      "BancoDolar": new FormControl(''),
      "Alta_Usuario": new FormControl(this.user.Usuario, Validators.required),
    });

    this.formConfig = new FormGroup({
      FlagFirmaDesembolso: new FormControl(true, []),
      FlagPagoInteres: new FormControl(false, []),
      FlagTasa: new FormControl(true, []),
      FlagPorcentajeAdelanto: new FormControl(false, []),
      FlagGastosAsociados: new FormControl(false, []),
      TasaMinima: new FormControl('0.0', []),
      TasaMaxima: new FormControl('0.0', []),
      PorcentajeAdelantoMinimo: new FormControl('0.0', []),
      PorcentajeAdelantoMaximo: new FormControl('0.0', []),
      GastoMinimo: new FormControl('0.0', []),
      GastoMaximo: new FormControl('0.0', []),
    });
    this.esConfirming = this.esConfirmingServicio(this.tipoServicioElement);
  }

  ngOnInit() {
    this.inicializarIdEmpresa();
    if (this.idEmpresa) {
      this.ListarRepresentantesEmpresa(this.idEmpresa);
      this.ListarReferenciasBancarias(this.idEmpresa);
    }
  }

  estaCargando(): boolean {
    return this.loading || this.cargandoContactos || this.cargandoBancos;
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.sincronizarFirmantes();
      this.cdr.detectChanges();
    }, 300);
  }

  private sincronizarFirmantes(): void {
    const ifItems = this.obtenerSeleccionFirmantesIF();
    const cliItems = this.obtenerSeleccionFirmantesCLI();
    if (ifItems.length) {
      this.selectedItems = ifItems.slice();
    }
    if (cliItems.length) {
      this.selectedItemsCLI = cliItems.slice();
    }
  }

  private obtenerSeleccionFirmantesIF(): any[] {
    if (this.multiselectIF && this.multiselectIF.selectedItems && this.multiselectIF.selectedItems.length) {
      return this.multiselectIF.selectedItems;
    }
    return this.selectedItems || [];
  }

  private obtenerSeleccionFirmantesCLI(): any[] {
    if (this.multiselectCLI && this.multiselectCLI.selectedItems && this.multiselectCLI.selectedItems.length) {
      return this.multiselectCLI.selectedItems;
    }
    return this.selectedItemsCLI || [];
  }

  puedeGuardar(): boolean {
    if (this.estaCargando() || this.save) {
      return false;
    }
    
    if (this.obtenerSeleccionFirmantesCLI().length === 0) {
      return false;
    }
    const f = this.formularioGenerarContrato;
    if (!f.get('idEmpresa').value || !f.get('Fecha_Inicio').value || !f.get('Fecha_Final').value) {
      return false;
    }
    if (!f.get('Tipo_Servicio').value) {
      return false;
    }
    return true;
  }

  private inicializarIdEmpresa(): void {
    if (this.idEmpresaProveedor) {
      this.idEmpresa = this.idEmpresaProveedor;
    } else {
      this.idEmpresa = this.obtenerIdEmpresaDesdeRuta();
    }
    if (this.idEmpresa) {
      this.formularioGenerarContrato.patchValue({ idEmpresa: this.idEmpresa });
      this.formularioGenerarContrato.get('idEmpresa').updateValueAndValidity();
    }
    this.routerActive.params.subscribe(params => {
      if (params['id']) {
        this.idEmpresa = params['id'];
        this.formularioGenerarContrato.patchValue({ idEmpresa: this.idEmpresa });
        this.formularioGenerarContrato.get('idEmpresa').updateValueAndValidity();
        this.cdr.detectChanges();
      }
    });
  }

  private obtenerIdEmpresaDesdeRuta(): string {
    let route: ActivatedRoute = this.routerActive;
    while (route) {
      const id = route.snapshot.params['id'];
      if (id) {
        return id;
      }
      route = route.parent;
    }
    return '';
  }

  esConfirmingServicio(tipoServicio?: any): boolean {
    const id = tipoServicio != null ? tipoServicio : this.formularioGenerarContrato.get('Tipo_Servicio').value;
    return Number(id) === Number(this.Id_Confirming);
  }

  private esConfirmingPorCodigo(codigo: string): boolean {
    const c = (codigo || '').toUpperCase();
    return c === 'CONF' || c.indexOf('CONFIRM') >= 0;
  }

  private obtenerCodigoTipoServicio(tipos: any[], tipoId: any): string {
    const item = (tipos || []).find(t => Number(t.idGuia) === Number(tipoId));
    return item && item.Codigo ? String(item.Codigo) : '';
  }

  /** Id de guía que usa el API (FACT/DESC por id_empresa del factor). */
  private resolverTipoServicioParaFactor(tipos: any[]): any {
    const tipoId = this.formularioGenerarContrato.get('Tipo_Servicio').value;
    const selected = (tipos || []).find(t => Number(t.idGuia) === Number(tipoId));
    const factorId = Number(this.user.id_empresa);

    if (selected && selected.Codigo) {
      const porEmpresa = (tipos || []).find(t =>
        String(t.Codigo) === String(selected.Codigo) && Number(t.id_empresa) === factorId
      );
      if (porEmpresa) {
        return porEmpresa.idGuia;
      }
      const codigo = String(selected.Codigo).toUpperCase();
      if (codigo === 'FACT') {
        return this.Id_Factoring;
      }
      if (codigo === 'DESC') {
        return this.Id_Descuento;
      }
      if (this.esConfirmingPorCodigo(codigo)) {
        return this.Id_Confirming;
      }
    }

    if (Number(tipoId) === 1378) {
      return this.Id_Factoring;
    }
    return tipoId;
  }

  tipoServicioSelect(event) {
    const ctrl = this.formularioGenerarContrato.get('Pagare');
    if (event == this.Id_Descuento) {
      this.formularioGenerarContrato.controls["Pagare"].setValue(true);
      ctrl.disable();
    } else {
      ctrl.enable();
    }
    this.formularioGenerarContrato.controls['Tipo_Servicio'].setValue(event);
    this.guiasService.TipoServicio.pipe(take(1)).subscribe(tipos => {
      const codigo = this.obtenerCodigoTipoServicio(Array.isArray(tipos) ? tipos : [], event);
      this.esConfirming = this.esConfirmingPorCodigo(codigo) || this.esConfirmingServicio(event);
      this.cdr.detectChanges();
    });
  }

  representanteIF(event) {
    this.selectedItems = event ? (Array.isArray(event) ? event.slice() : [event]) : [];
    this.sincronizarFirmantes();
    this.cdr.detectChanges();
  }
  representanteCLI(event) {
    this.selectedItemsCLI = event ? (Array.isArray(event) ? event.slice() : [event]) : [];
    this.sincronizarFirmantes();
    this.cdr.detectChanges();
  }

  private normalizarListaContactos(res: any): any[] {
    if (Array.isArray(res)) {
      return res;
    }
    if (res && typeof res === 'object') {
      const data = res.data != null ? res.data : res;
      return Array.isArray(data) ? data : [];
    }
    return [];
  }

  private prepararContactosParaMultiselect(contactos: any[]): any[] {
    return (contactos || []).map(contacto => ({
      ...contacto,
      NombreCorreo: contacto.NombreCorreo || ((contacto.Nombre_de_Contacto || '') + (contacto.Correo ? ' - ' + contacto.Correo : ''))
    }));
  }

  calcularFechaFin() {
    let now = moment(this.formularioGenerarContrato.controls["Fecha_Inicio"].value._d).add(1, 'years').subtract(1, 'days');
    this.formularioGenerarContrato.controls["Fecha_Final"].setValue(now);
  }

  ListarRepresentantesEmpresa(idEmpresa) {
    this.guiasService.setDataRepresentanteCLI([]);
    this.cargandoContactos = true;
    this.empresasService.obtenerContactosEmpresa(idEmpresa).subscribe(
      res => {
        this.guiasService.TipoContacto.pipe(take(1)).subscribe(
          tipoContacto => {
            try {
              this.rProvCombo = this.normalizarListaContactos(res);
              let guiaTipo = null;
              if (Array.isArray(tipoContacto)) {
                guiaTipo = tipoContacto.find(state => state.Codigo && state.Codigo.toLowerCase().indexOf('rl') === 0);
              }
              if (guiaTipo && guiaTipo.idGuia) {
                this.rProvCombo = this.rProvCombo.filter(
                  state => state.Des_Estado && state.Des_Estado.toLowerCase().indexOf('activo') === 0 && state.Tipo_de_Contacto === guiaTipo.idGuia
                );
              } else {
                this.rProvCombo = this.rProvCombo.filter(
                  state => state.Des_Estado && state.Des_Estado.toLowerCase().indexOf('activo') === 0
                );
              }
              this.rProvCombo = this.prepararContactosParaMultiselect(this.rProvCombo);
              this.guiasService.setDataRepresentanteCLI(this.rProvCombo);
            } finally {
              this.cargandoContactos = false;
              setTimeout(() => {
                this.sincronizarFirmantes();
                this.cdr.detectChanges();
              }, 200);
            }
          },
          () => {
            this.rProvCombo = this.prepararContactosParaMultiselect(this.normalizarListaContactos(res));
            this.guiasService.setDataRepresentanteCLI(this.rProvCombo);
            this.cargandoContactos = false;
            this.cdr.detectChanges();
          }
        );
      }, (err: HttpErrorResponse) => {
        this.cargandoContactos = false;
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "Los representantes no pudieron ser obtenidos. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        })
      });
  }

  ListarReferenciasBancarias(idProvi) {
    this.cargandoBancos = true;
    this.empresasService.obtenerReferenciasBancariasEmpresa(idProvi).subscribe(
      res => {
        this.rProvRefBancarias = res;
        this.rProvRefBancariasDolares = this.rProvRefBancarias.filter(
          state => state.Moneda == this.Label_id_dolares && state.Estado.toLowerCase().indexOf('activo') === 0 && state.FlgPredeterminado == 1
        );
        this.rProvRefBancarias = this.rProvRefBancarias.filter(
          state => state.Moneda == this.Label_id_soles && state.Estado.toLowerCase().indexOf('activo') === 0 && state.FlgPredeterminado == 1
        );
        if (this.rProvRefBancarias.length === 1) {
          this.SetearRefBancariaSoles(this.rProvRefBancarias[0].idCuenta);
        }
        if (this.rProvRefBancariasDolares.length === 1) {
          this.SetearRefBancariaDolares(this.rProvRefBancariasDolares[0].idCuenta);
        }
        this.cargandoBancos = false;
        this.cdr.detectChanges();
      }, err => {
        Swal.fire({
          title: "¡Algo salió mal!",
          footer: err.error['error'],
          type: "warning",
          allowOutsideClick: true,
          heightAuto: false
        });
        this.cargandoBancos = false;
        this.cdr.detectChanges();
      }
    )
  }

  crearContratoMarco() {
    this.formatearFormSend();
    this.addDataSelects();

    if (!this.dataEnviar.Firmantes || !this.dataEnviar.Firmantes.length) {
      Swal.fire({
        title: '¡¡Advertencia!',
        text: 'Seleccione al menos un firmante.',
        type: 'warning',
        allowOutsideClick: true,
        heightAuto: false
      });
      return;
    }

    this.guiasService.TipoServicio.pipe(take(1)).subscribe(tipos => {
      const tiposArr = Array.isArray(tipos) ? tipos : [];
      const tipoServicioId = this.resolverTipoServicioParaFactor(tiposArr);
      const codigo = this.obtenerCodigoTipoServicio(tiposArr, tipoServicioId);
      const esConfirming = this.esConfirmingPorCodigo(codigo) || this.esConfirmingServicio(tipoServicioId);

      this.enviarContratoMarcoAlApi(tipoServicioId, esConfirming);
    });
  }

  private enviarContratoMarcoAlApi(tipoServicioId: any, esConfirming: boolean): void {
    if (this.formularioGenerarContrato.controls['Pagare'].value == false) {
      this.Pagare = 'N';
    } else {
      this.Pagare = 'S';
    }

    const firmantesCLI = this.obtenerSeleccionFirmantesCLI();
    const firmantesIF = this.obtenerSeleccionFirmantesIF();

    this.dataEnviar.idEmpresa = this.formularioGenerarContrato.controls['idEmpresa'].value;
    this.dataEnviar.idEmpresa_Factor = this.user.id_empresa;
    this.dataEnviar.Tipo_Servicio = tipoServicioId;
    this.dataEnviar.Tipo_Proceso = this.Id_Tipo_Proceso_CM;
    this.dataEnviar.idGuia = this.Id_Tipo_Proceso_CM;
    this.dataEnviar.Fecha_Inicio = this.formularioGenerarContrato.controls['Fecha_Inicio'].value;
    this.dataEnviar.Fecha_Final = this.formularioGenerarContrato.controls['Fecha_Final'].value;
    this.dataEnviar.Pagare = this.Pagare;
    this.dataEnviar.IF_Representante_Legal_1 = firmantesIF.length ? firmantesIF[0].idRepresentanteIF : '';
    this.dataEnviar.PRV_Representante_Legal_1 = firmantesCLI.length ? firmantesCLI[0].idContacto : '';
    this.dataEnviar.IF_Representante_Legal_2 = '';
    this.dataEnviar.PRV_Representante_Legal_2 = '';
    this.dataEnviar.Correo = firmantesCLI.length ? (firmantesCLI[0].Correo || '') : '';
    this.dataEnviar.BancoSoles = this.formularioGenerarContrato.controls['BancoSoles'].value;
    this.dataEnviar.BancoDolar = this.formularioGenerarContrato.controls['BancoDolar'].value;
    this.dataEnviar.Alta_Usuario = this.formularioGenerarContrato.controls['Alta_Usuario'].value;
    this.dataEnviar.Firmantes = this.dataEnviar.Firmantes || [];
    this.dataEnviar.FirmantesIF = this.dataEnviar.FirmantesIF || [];
    this.dataEnviar.FirmantesAd = this.dataEnviar.FirmantesAd || [];

     

    if (esConfirming) {
      this.armarPayloadConfirming();
    } else {
      delete this.dataEnviar.Config;
      delete this.dataEnviar.Linea;
    }

    this.loading = true;
    this.empresasService.guardarContratoMarco(this.dataEnviar)
      .subscribe(res => {
        this.loading = false;
        this.save = true;
        Swal.fire({
          title: '¡Registro exitoso!',
          text: '¿Desea enviar Pagaré a firma Electrónica?',
          type: "success",
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si, enviar',
          cancelButtonText: 'No, cancelar',
          heightAuto: false
        }).then((result) => {
          if (result.value) {
            this.dataContract = res;
            this.dataEnviarKeynua.IDCMarco = this.dataContract.IDCMarco
            this.enviarContratoMarcoElectronico(this.dataEnviarKeynua);
          } else if (
            result.dismiss === Swal.DismissReason.cancel
          ) {
            this.loading = false;
          }
        });

      }, (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "El Pagaré no pudo ser registrado. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        });
      });
  }

  enviarContratoMarcoElectronico(dataEnviarKeynua) {

    this.firmaElectronicaService.enviarContratoMarcoElectronico(dataEnviarKeynua).subscribe(
      res => {
        this.showNotification('success', 'top', 'right', 'Pagaré enviado satisfactoriamente para su firma digital.');
      }, err => {
        if (err.error.message) {
          this.showNotification('warning', 'top', 'right', 'No se pudo enviar Pagaré a firma electrónica. \n Error: ' + err.error.message);
        } else {
          let error = "";
          error = err.error.error;
          this.showNotification('warning', 'top', 'right', 'No se pudo enviar Pagaré a firma electrónica. \n Error: ' + error);
        }

      }
    );
  }

  formatearFormSend() {
    let fec_ini = this.datePipe.transform(this.formularioGenerarContrato.controls["Fecha_Inicio"].value, "yyyy-MM-dd");
    let fec_fin = this.datePipe.transform(this.formularioGenerarContrato.controls["Fecha_Final"].value, "yyyy-MM-dd");

    this.formularioGenerarContrato.controls["Fecha_Inicio"].setValue(fec_ini);
    this.formularioGenerarContrato.controls["Fecha_Final"].setValue(fec_fin);
  }

  private normalizarFlagsConfig(): void {
    const flags = ['FlagFirmaDesembolso', 'FlagPagoInteres', 'FlagTasa', 'FlagPorcentajeAdelanto', 'FlagGastosAsociados'];
    flags.forEach(name => {
      const ctrl = this.formConfig.controls[name];
      ctrl.setValue(ctrl.value === true || ctrl.value === 1 ? 1 : 0);
    });
  }

  private armarPayloadConfirming(): void {
    this.normalizarFlagsConfig();
    const altaUsuario = this.formularioGenerarContrato.controls['Alta_Usuario'].value;
    const altaFecha = this.datePipe.transform(this.Fecha, 'yyyy-MM-dd');

    this.dataEnviar.Config = [{
      Alta_Usuario: altaUsuario,
      Alta_Canal: 'W',
      Alta_Fecha: altaFecha,
      FlagFirmaDesembolso: this.formConfig.controls['FlagFirmaDesembolso'].value,
      FlagGastosAsociados: this.formConfig.controls['FlagGastosAsociados'].value,
      FlagPagoInteres: this.formConfig.controls['FlagPagoInteres'].value,
      FlagPorcentajeAdelanto: this.formConfig.controls['FlagPorcentajeAdelanto'].value,
      FlagTasa: this.formConfig.controls['FlagTasa'].value,
      GastoMaximo: Number(this.formConfig.controls['GastoMaximo'].value / 100).toFixed(4),
      GastoMinimo: Number(this.formConfig.controls['GastoMinimo'].value / 100).toFixed(4),
      PorcentajeAdelantoMaximo: Number(this.formConfig.controls['PorcentajeAdelantoMaximo'].value / 100).toFixed(4),
      PorcentajeAdelantoMinimo: Number(this.formConfig.controls['PorcentajeAdelantoMinimo'].value / 100).toFixed(4),
      TasaMaxima: Number(this.formConfig.controls['TasaMaxima'].value / 100).toFixed(4),
      TasaMinima: Number(this.formConfig.controls['TasaMinima'].value / 100).toFixed(4),
    }];

    const lineaCOP = this.lineaSoles === '' || this.lineaSoles == null ? 0 : Number(this.lineaSoles);
    const lineaUSD = this.lineaDolares === '' || this.lineaDolares == null ? 0 : Number(this.lineaDolares);

    this.dataEnviar.Linea = [
      {
        Moneda: 2,
        LineaTotal: lineaCOP.toFixed(2),
        LineaDisponible: lineaCOP.toFixed(2),
        Alta_Usuario: altaUsuario,
        Alta_Canal: 'W',
        Alta_Fecha: altaFecha,
      },
      {
        Moneda: 3,
        LineaTotal: lineaUSD.toFixed(2),
        LineaDisponible: lineaUSD.toFixed(2),
        Alta_Usuario: altaUsuario,
        Alta_Canal: 'W',
        Alta_Fecha: altaFecha,
      },
    ];
  }

  addDataSelects() {
    this.sincronizarFirmantes();
    const firmantesCLI = this.obtenerSeleccionFirmantesCLI();
    const firmantesIF = this.obtenerSeleccionFirmantesIF();
    this.dataEnviar.Firmantes = [];
    this.dataEnviar.FirmantesIF = [];
    this.dataEnviar.FirmantesAd = [];
    firmantesCLI.forEach(item => {
      const firmanteCli = {
        idGuia: item.idContacto,
        Nombre_Firmante: item.Nombre_de_Contacto,
        Correo: item.Correo,
        Telefono: item.NroMovil_Laboral,
        Tipo_Doc_Identificacion: item.Tipo_Documento_Identidad,
        Tipo_Doc_Identificacion_Dsc: item.Tipo_Documento_Identidad_Dsc,
        Num_Doc_Identificacion: item.Nro_Documento_Identidad,
        Tipo_Firmante: item.Rol_del_Contacto,
        Cargo: item.Rol_Del_Contacto_Dsc,
        Raz_Social: item.Razon_Social,
        RUC: item.Num_Doc_Identificacion,
        Direccion: item.Direccion_Fiscal,
        Distrito: item.Distrito,
        Provincia: item.Provincia,
        Departamento: item.Departamento
      };
      this.dataEnviar.Firmantes.push(firmanteCli);
      this.dataEnviar.FirmantesAd.push(firmanteCli);
    });
    firmantesIF.forEach(item => {
      const firmanteIf = Object.assign({}, item, {
        idGuia: item.idRepresentanteIF || item.idGuia
      });
      this.dataEnviar.Firmantes.push(firmanteIf);
      this.dataEnviar.FirmantesIF.push(firmanteIf);
    });
  }

  SetearCorreo(idContacto) {
    if (this.rProvCombo.length > 0) {

      this.rProvArray = this.rProvCombo.filter(
        state => state.idContacto == idContacto
      );

      this.formularioGenerarContrato.controls['Correo'].setValue(this.rProvArray[0].Correo);
      this.formularioGenerarContrato.controls['PRV_Representante_Legal_1'].setValue(this.rProvArray[0].idContacto);
    }
  }

  SetearRefBancariaSoles(idCuenta) {
    if (this.rProvRefBancarias.length > 0) {
      this.rRefBancariaArray = this.rProvRefBancarias.filter(
        state => state.idCuenta == idCuenta
      );
      let descripcionBanco =
        ((this.rRefBancariaArray[0].Tipo_de_Cuenta == 90) ? "A" : "C") + "|" +
        this.rRefBancariaArray[0].NroCuenta + "|" +
        this.rRefBancariaArray[0].Banco_Dsc + "|" +
        ((this.rRefBancariaArray[0].Moneda == this.Label_id_dolares) ? "D" : "S") + "|" +
        this.rRefBancariaArray[0].CCI + "|" +
        this.rRefBancariaArray[0].idCuenta;
      this.formularioGenerarContrato.controls['BancoSoles'].setValue(descripcionBanco);
    }
  }

  SetearRefBancariaDolares(idCuenta) {
    if (this.rProvRefBancariasDolares.length > 0) {
      this.rRefBancariaArray = this.rProvRefBancariasDolares.filter(
        state => state.idCuenta == idCuenta
      );
      let descripcionBanco =
        ((this.rRefBancariaArray[0].Tipo_de_Cuenta == 90) ? "A" : "C") + "|" +
        this.rRefBancariaArray[0].NroCuenta + "|" +
        this.rRefBancariaArray[0].Banco_Dsc + "|" +
        ((this.rRefBancariaArray[0].Moneda == this.Label_id_dolares) ? "D" : "S") + "|" +
        this.rRefBancariaArray[0].CCI + "|" +
        this.rRefBancariaArray[0].idCuenta;
      this.formularioGenerarContrato.controls['BancoDolar'].setValue(descripcionBanco);
    }
  }

  nuevoContacto() {
    this.idContactoS = "";
    this.empresasService.addContactoEmpresa = true;
    this.abrirAgregarContacto = true;
  }

  SetearRepIF(idRepresentanteIF) {
    this.formularioGenerarContrato.controls['IF_Representante_Legal_1'].setValue(idRepresentanteIF);
  }

  CerrarPopUp() {
    this.cerrarContratoMarcoNuevo.emit();
    this.guiasService.setDataRepresentanteCLI([]);
  }
  CerrarPopUpContacto(click: boolean) {
    this.abrirAgregarContacto = false;
  }

  Refresh() {
    this.ngOnInit();
  }

  showNotification(type, from, align, message) {

    $.notify({
      icon: "notifications",
      message: message
    }, {
      type: type,
      timer: 4000,
      placement: {
        from: from,
        align: align
      },
      template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
        '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
        '<i class="material-icons" data-notify="icon">notifications</i> ' +
        '<span data-notify="title">{1}</span> ' +
        '<span data-notify="message">{2}</span>' +
        '<div class="progress" data-notify="progressbar">' +
        '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
        '</div>' +
        '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
    });
  }

}
